<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'settings.changePasswordTitle' | translate }}</mat-panel-title>
  </mat-expansion-panel-header>
  <p class="setting-description">{{ 'settings.changePasswordDescription' | translate }}</p>
  <button mat-flat-button class="setting-button" [disabled]="loading()" (click)="changePassword()">
    {{ 'settings.changePassword' | translate }}
  </button>
</mat-expansion-panel>
